// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"619":"pages-EventPage","2015":"pages-ArtistPage-ArtistPage","2593":"pages-YourFavourites-YourFavourites","4974":"pages-NewsPage","6358":"pages-UserPage-UserAppreciationPage"}[chunkId] + ".css";
};